<script>
    import { executiveSummaryStore } from './stores.js';
    import { ScaleOut } from 'svelte-loading-spinners';

    let executiveSummary;
    let showSummary = false;
    executiveSummaryStore.subscribe(({ executiveSummary: newExecutiveSummary }) => {
        executiveSummary = newExecutiveSummary;
    });

    function toggleSummary() {
        showSummary = !showSummary;
    }
</script>
<div class="bg-blueish-black border-4 rounded-lg left-10 space-x-2 p-3">
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div class="flex items-center justify-between cursor-pointer" on:click={toggleSummary}>
        <h3 class="text-white pl-2">Executive Summary</h3>
        <span class="text-white">
            {#if showSummary}
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M18.75 19.5l-7.5-7.5 7.5-7.5m-6 15L5.25 12l7.5-7.5" />
                </svg>
            {:else}
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 4.5l7.5 7.5-7.5 7.5m-6-15l7.5 7.5-7.5 7.5" />
                </svg>
            {/if}
        </span>
    </div>
</div>
{#if showSummary}
    {#if executiveSummary}
        <div class="absolute w-2/6 bg-blueish-black opacity-90 border-4 rounded-lg space-x-2 p-3" style="left: 20%">
            <div class="text-white pt-3">{@html executiveSummary }</div>
        </div>
    {:else}
        <div class="absolute w-2/6 bg-blueish-black opacity-90 border-4 rounded-lg space-x-2 p-3 flex justify-center items-center" style="left: 20%">
            <ScaleOut size="100" color="#02A4FF" unit="px" duration="1s"  />
        </div>
    {/if}
{/if}